import React, {useEffect, useRef, useState} from 'react';
import {Controller, useForm, useFormState} from 'react-hook-form';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
} from 'react-native';
import {Color, globalFontStyle, globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import {globalFormStyle} from '../../../assets/GlobalStyle/globalFormStyle';
import { Button } from '../../../components/core/Button';
import { Input } from '../../../components/core/Input';
import { Icon } from '@iconify/react';
import TradingFeeSellCDA from '../childComponents/tradingFeeSellCda';
import Slippage from '../childComponents/slippage';
import {useSelector} from 'react-redux';
import {Network} from '../../../utils/network';
import {
  globalConfigurableData,
  globalConst,
  GlobalScreens,
} from '../../../utils/globalConstant';
import {usePolling} from '../../../common/usePolling';
import {
  trackMoengageEvent,
  RegEx,
  isMobile,
  giveCorrectPrice,
  getCounterRange,
  getPrice,
  getModifiedRange,
  getRangeMod,
  getFieldValidation,
  getReturns,
  defaultRange,
  getSharesOnAddSub,
  getDefaultSharesByPriceRange,
  getMinSellSharesByPriceRange,
} from '../../../utils/commonMethods';
import OutCome from '../childComponents/outcome';
import Width from '../../../assets/Width';
import {useNavigation, useRoute} from '@react-navigation/native';
import MultiSlider from '@ptomasroos/react-native-multi-slider';
import {globalImport} from '../../../common/globalImports';
import {ic_minus, ic_plus} from '../../../utils/images';
import FastImage from '../../../common/FastImage';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import {convert} from '../../../locale/translateText';
import {INDIA} from '../../../utils/constants';

const SingleOrderSell = ({eventDetails, orderStatus, isLimit, closeSheet}) => {
  const route = useRoute();
  const contestId = route?.params?.contestId;
  const navigation = useNavigation();
  const {probe, isYes} = eventDetails;
  const [YesSelected, setYesSelected] = useState(!!isYes);
  const isCDA = eventDetails?.probe?.is_price_editable;
  let globalConfigData = useSelector(
    ({utilReducer}) => utilReducer.globalConfigData,
  );
  const logedIn = useSelector(({utilReducer}) => utilReducer.isAppLogin);
  const ref = useRef(null);
  const range = getModifiedRange(probe.range);
  const rangeMod = getRangeMod();
  const steps =
    range === rangeMod?.min || range === rangeMod?.mid ? false : true;

  const isRange50 = range === rangeMod?.mid;
  const valuePrice =
    (YesSelected
      ? giveCorrectPrice({yPrice: probe?.execution_price_yes})
      : giveCorrectPrice({nPrice: probe?.execution_price_no})) || steps
      ? range
      : 0;

  const valueShareMaxHoldings =
    (YesSelected
      ? getReturns(probe?.total_matched_contract_yes)
      : getReturns(probe?.total_matched_contract_no)) || 0;

  const valueShareDefault =
    valueShareMaxHoldings == 0
      ? 0
      : !eventDetails?.probe?.is_price_editable
      ? valueShareMaxHoldings.toFixed(2) < 0.1
        ? parseFloat(valueShareMaxHoldings.toFixed(2))
        : getDefaultSharesByPriceRange()
      : contestId
      ? parseFloat(valueShareMaxHoldings.toFixed(2))
      : getDefaultSharesByPriceRange();
  const [tradingFee, setTradingFee] = useState(0);
  const [actualPrice, setActualPrice] = useState(valuePrice);
  var [cdaActual, setCdaActual] = useState({
    price: valuePrice,
    share: valueShareDefault,
  });
  const [slippage, setSlippage] = useState(
    globalConfigData?.slippage?.slpType === 'limited' ? true : false,
  );

  let userInfo = useSelector(({profile}) => profile?.profileData);
  const isCommunityEvent = eventDetails?.probe?.category === 'Community Events';

  const handleSlippage = e => {
    // e.preventDefault();
    setSlippage(!slippage);
  };

  const {
    control,
    formState: {errors, isValid, isSubmitting},
    handleSubmit,
    reset,
    watch,
    setValue,
  } = useForm({mode: 'onChange'});

  const {dirtyFields} = useFormState({
    control,
  });

  const counterRange = getCounterRange();

  usePolling(
    () => {
      getTruePrice();
    },
    3000,
    !eventDetails?.probe?.is_price_editable &&
      !(Object.keys(dirtyFields).length <= 0),
  );

  useEffect(() => {
    if (Object.keys(dirtyFields).length <= 0) {
      reset({
        currentPrice: giveCorrectPrice(
          YesSelected ? {yPrice: valuePrice} : {nPrice: valuePrice},
        ),
        currentShare: eventDetails?.probe?.is_price_editable
          ? valueShareDefault.toFixed(0)
          : valueShareDefault.toFixed(2),
      });
      if (valueShareMaxHoldings && eventDetails.probe?.is_price_editable) {
        getExitPos(true);
      }
    }
  }, [valuePrice, valueShareDefault]);

  const getDefaultPrice = () => {
    if (!eventDetails?.probe) return 0;
    
    return YesSelected 
      ? (eventDetails.probe.newSellPriceYes || eventDetails.probe.newYCP || 0)
      : (eventDetails.probe.newSellPriceNo || eventDetails.probe.newNCP || 0);
  };

  const watchprice = watch("currentPrice") || getDefaultPrice();

  useEffect(() => {
    if (!isLimit) {
      setValue("currentPrice", getDefaultPrice(), {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  }, [YesSelected, isLimit, eventDetails]);

  const validatePrice = (value) => {
    if (!value) return "Price is required";
    const price = parseFloat(value);
    const minPrice = 1;
    const maxPrice = 99;
    
    if (price < minPrice || price > maxPrice) {
      return `Price should be between ${minPrice} and ${maxPrice}`;
    }
    return true;
  };

  const watchshare = watch(
    'currentShare',
    eventDetails?.probe?.is_price_editable
      ? valueShareDefault.toFixed(0)
      : valueShareDefault.toFixed(2),
  );
  useEffect(() => {
    if (!eventDetails?.probe?.is_price_editable) {
      getTruePrice();
    }
  }, [watchshare, YesSelected]);

  const getExitPos = async (isFromBase = false) => {
    const anc = {
      callvalue: YesSelected ? 'Y' : 'N',
      eventid: eventDetails?.probe.id,
    };
    const res = await Network.getExiPosition(anc);
    if (res?.data) {
      setCdaActual({
        ...cdaActual,
        price: giveCorrectPrice(
          YesSelected
            ? {yPrice: res?.data?.exitOption?.coins}
            : {nPrice: res?.data?.exitOption?.coins},
        ),
        share: valueShareDefault,
      });
      reset({
        currentPrice: giveCorrectPrice(
          YesSelected
            ? {yPrice: res?.data?.exitOption?.coins}
            : {nPrice: res?.data?.exitOption?.coins},
        ),
        currentShare: eventDetails?.probe?.is_price_editable
          ? valueShareDefault.toFixed(0)
          : valueShareDefault.toFixed(2),
      });
    } else {
      if (isFromBase) {
        setCdaActual({
          ...cdaActual,
          price: valuePrice,
          share: valueShareDefault,
        });
      }
    }
  };
  let region = userInfo?.region_code ?? 'INDIA';
  const onPlaceOrder = async data => {
    if (!userInfo?.isProfileComplete) {
      isMobile() && closeSheet();
      navigation.navigate('Profile');
      return;
    }
    let inputObj = {
      appVersion: globalConst.appVersion,
      callvalue: YesSelected ? 'Y' : 'N',
      coins: !eventDetails?.probe?.is_price_editable
        ? parseFloat(actualPrice).toFixed(
            2,
          ) /*need confirmation regarding this*/
        : parseFloat(cdaReturnPrice()),
      noofcontracts: !eventDetails?.probe?.is_price_editable
        ? returnCorrectShare()
        : parseFloat(cdaReturnShare()).toFixed(2),
      probeid: eventDetails?.probe.id,
      tradeType: 'Sell',
      trade_initiated_price: getReturns(watchprice),
      preventSlippage: slippage,
      islimit: isLimit,
      range: defaultRange.end,
    };
    inputObj = {
      ...inputObj,
      ...{
        coins: parseFloat(inputObj.coins),
        noofcontracts: parseFloat(inputObj.noofcontracts),
        trade_initiated_price: parseFloat(inputObj.coins),
      },
    };

    if (!isSubmitting) {
      const res = await Network.sellOrder(inputObj, true);
      trackMoengageEvent('Event Sell', {
        Type: eventDetails?.probe?.is_price_editable ? 'CDA' : 'IM',
        Category: '',
        SubCategory: '',
        id: eventDetails?.probe?.id,
        Side: res?.data?.call?.callvalue === 'Y' ? 'Yes' : 'No',
        CostShare: res?.data?.call?.coins,
        Shares: res?.data?.call?.noofcontracts,
        Profit: '',
        MarketOpen: new Date(eventDetails?.probe?.createdat),
        MarketEnd: new Date(eventDetails?.probe?.endsat),
        MarketSettlement: new Date(eventDetails?.probe?.settledate),
        SettlementLink: eventDetails?.probe?.source,
        tradingfees: '',
        isContest: contestId ? true : false,
      });

      orderStatus(res?.data);
      if (res?.success) {
      } else {
      }
    }
  };

  const getTruePrice = async () => {
    if (
      +watchshare >= 0.1 &&
      +watchshare <= +valueShareMaxHoldings.toFixed(2)
    ) {
      const instantPircePayload = {
        eventId: eventDetails?.probe?.id,
        action: 'sell',
        callvalue: YesSelected ? 'Y' : 'N',
        noofcontracts: returnCorrectShare(),
        range: defaultRange.end,
      };
      let res;
      if (probe?.is_variable_liquidity_pool) {
        res = await Network.getInstantUpdatedPrice(instantPircePayload);
      } else {
        res = await Network.getInstantPrice(instantPircePayload);
      }
      if (res?.data?.data?.ex_price) {
        setValue(
          'currentPrice',
          res?.data?.data?.ex_price
            ? giveCorrectPrice(
                YesSelected
                  ? {yPrice: res?.data?.data?.ex_price}
                  : {nPrice: res?.data?.data?.ex_price},
              )
            : 0,
        );
        setActualPrice(
          giveCorrectPrice(
            YesSelected
              ? {yPrice: res?.data?.data?.ex_price}
              : {nPrice: res?.data?.data?.ex_price},
          ),
        );
      } else {
        setValue('currentPrice', 0);
        setActualPrice(0);
      }

      //setTradingFee(res?.data?.data?.trading_fee || 0);
    }
  };

  const returnCorrectShare = () => {
    if (dirtyFields.currentShare) {
      return valueShareMaxHoldings.toFixed(2) === +watchshare
        ? valueShareMaxHoldings
        : watchshare;
    } else {
      return valueShareDefault;
    }
  };

  const cdaReturnShare = () => {
    if (dirtyFields.currentShare) {
      return valueShareMaxHoldings.toFixed(2) === watchshare
        ? valueShareMaxHoldings
        : watchshare;
    } else {
      return cdaActual?.share;
    }
  };

  const cdaReturnPrice = () => {
    if (dirtyFields.currentPrice) {
      return watchprice;
    } else {
      return cdaActual?.price;
    }
  };

  const onMaxShare = () => {
    setValue('currentShare', valueShareMaxHoldings.toFixed(2).toString(), {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const yesNoSelected = value => {
    if (value) {
      setYesSelected(true);
    } else {
      setYesSelected(false);
    }
  };

  const limitShareUpdate = getSharesOnAddSub(1);

  const onCounterPriceUpdate = val => {
    if (
      val === 'decrement' &&
      getPrice(+watchprice - counterRange?.addSubVar) >= counterRange?.min
    ) {
      setValue(
        'currentPrice',
        getPrice(+watchprice - counterRange?.addSubVar).toString(),
        {
          shouldValidate: true,
          shouldDirty: true,
        },
      );
    } else if (
      val === 'increment' &&
      getPrice(+watchprice + counterRange?.addSubVar) <= counterRange?.max
    ) {
      setValue(
        'currentPrice',
        getPrice(+watchprice + counterRange?.addSubVar).toString(),
        {
          shouldValidate: true,
          shouldDirty: true,
        },
      );
    }
  };

  const onCounterPriceUpdateSlider = val => {
    if (
      val === 'decrement' &&
      getPrice(+watchprice - range) >= counterRange?.min
    ) {
      setValue('currentPrice', getPrice(+watchprice - range).toString(), {
        shouldValidate: true,
        shouldDirty: true,
      });
    } else if (
      val === 'increment' &&
      getPrice(+watchprice + range) <= counterRange?.max
    ) {
      setValue('currentPrice', getPrice(+watchprice + range).toString(), {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };

  const onCounterShareUpdate = val => {
    if (val === 'decrement' && +watchshare - limitShareUpdate >= 1) {
      setValue('currentShare', (+watchshare - limitShareUpdate).toString(), {
        shouldValidate: true,
        shouldDirty: true,
      });
    } else if (
      val === 'increment' &&
      +watchshare + limitShareUpdate <= valueShareMaxHoldings
    ) {
      setValue('currentShare', (+watchshare + limitShareUpdate).toString(), {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };

  return (
    <View ref={ref}>
      <View style={{paddingHorizontal: 15}}>
        <ScrollView
          style={globalStyle.buySellScroll}
          showsVerticalScrollIndicator={false}>
          <TouchableOpacity activeOpacity={1}>
            <OutCome YesSelected={YesSelected} yesNoSelected={yesNoSelected} />
            {(!eventDetails?.probe?.is_price_editable || !isLimit) && (
              <View
                style={[
                  globalFormStyle.tableContainerRowNewForm,
                  {alignItems: 'flex-start'},
                  {marginTop: 10, marginBottom: 10},
                ]}>
                <FormTextLabel labelStyles={styles.formTitle} label={'Price'} />

                <View>
                  <Text
                    style={[
                      globalFormStyle.fieldRight,
                      {
                        color: globalConfigurableData?.primaryTextColor,
                        textAlign: 'right',
                      },
                    ]}>
                    {(1 * watchprice)?.toFixed(2)}
                  </Text>
                  <FormTextLabel
                    labelStyles={globalFormStyle.fieldRight}
                    label={'At Market'}
                  />
                </View>
              </View>
            )}

            <View>
              {eventDetails?.probe?.is_price_editable && isLimit ? (
                <>
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      marginBottom: 10,
                      marginTop: 10,
                      alignItems: 'center',
                    }}>
                    <FormTextLabel
                      labelStyles={styles.formTitle}
                      label={'Price'}
                    />
                    {(steps && range) || isRange50 ? (
                      <Text style={styles.formTitle}>{parseFloat(watchprice).toFixed(2)}</Text>
                    ) : null}
                  </View>

                  {steps && range ? (
                    <View
                      style={{
                        marginBottom: 5,
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}>
                      <TouchableOpacity
                        onPress={() => onCounterPriceUpdateSlider('decrement')}>
                        <Icon
                          icon="mdi:minus"
                          width={20}
                          height={20}
                          color={globalConfigurableData.primaryTextColor1}
                        />
                      </TouchableOpacity>

                      <Controller
                        control={control}
                        name="currentPrice"
                        rules={{
                          required: "Price is required",
                          validate: validatePrice
                        }}
                        render={({field: {onChange, value}, fieldState: {error}}) => (
                          <>
                            {value ? (
                              <MultiSlider
                                onValuesChange={val => onChange(val[0])}
                                min={range}
                                enabledTwo={false}
                                sliderLength={
                                  !globalImport.isWeb
                                    ? Width.width - 120
                                    : ref?.current?.offsetWidth
                                    ? ref?.current?.offsetWidth - 120
                                    : 200
                                }
                                step={range}
                                snapped={true}
                                allowOverlap={true}
                                values={[+value]}
                                selectedStyle={{
                                  backgroundColor:
                                    GlobalScreens.SingleOrder
                                      .switchSliderSelectedColor,
                                }}
                                unselectedStyle={{
                                  backgroundColor:
                                    GlobalScreens.SingleOrder
                                      .switchSliderUnselectedColor,
                                }}
                                max={rangeMod?.max - range}
                                markerStyle={styles.sliderMarkerStyle}
                                trackStyle={styles.sliderTrackStyle}
                                customLabel={sliderPosition => {
                                  return (
                                    <View
                                      style={[
                                        styles.sliderLableParent,
                                        {
                                          left:
                                            sliderPosition.oneMarkerLeftPosition -
                                            5,
                                        },
                                      ]}>
                                      <View style={styles.sliderLabelChild}>
                                        <Text
                                          style={[
                                            globalFontStyle.appFontSubTextWeight,
                                            {
                                              color:
                                                globalConfigurableData.contrastTextColor1,
                                            },
                                          ]}>
                                          {sliderPosition.oneMarkerValue}
                                        </Text>
                                      </View>
                                    </View>
                                  );
                                }}
                              />
                            ) : null}
                          </>
                        )}
                      />
                      <TouchableOpacity
                        onPress={() => onCounterPriceUpdateSlider('increment')}>
                        <Icon
                          icon="mdi:plus"
                          width={20}
                          height={20}
                          color={globalConfigurableData.primaryTextColor1}
                        />
                      </TouchableOpacity>
                    </View>
                  ) : (
                    <>
                      {isRange50 ? null : (
                        <View>
                          <View style={{
                            flexDirection: 'row',
                            alignItems: 'center',
                            backgroundColor: globalConfigurableData.cardBgColor,
                            borderRadius: 8,
                            borderWidth: 1,
                            overflow: 'hidden',
                            borderColor: errors?.currentPrice ? Colors.red : globalConfigurableData.borderColor,
                          }}>
                            {!isCommunityEvent && (
                              <>
                                <TouchableOpacity
                                  onPress={() => onCounterPriceUpdate('decrement')}
                                  style={{
                                    height: 46,
                                    width: 46,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                  }}>
                                  <Icon
                                    icon="mdi:minus"
                                    width={20}
                                    height={20}
                                    color={globalConfigurableData.primaryTextColor1}
                                  />
                                </TouchableOpacity>
                                <View style={{
                                  width: 1,
                                  alignSelf: 'stretch',
                                  backgroundColor: errors?.currentPrice ? Colors.red : globalConfigurableData.borderColor,
                                }} />
                              </>
                            )}
                            <View style={{flex: 1}}>
                              <Input
                                name="currentPrice"
                                placeholder=""
                                control={control}
                                variant="large"
                                disabled={!logedIn || range === rangeMod?.mid}
                                containerStyle={{marginBottom: 0}}
                                style={{borderWidth: 0}}
                                inputStyle={{
                                  borderWidth: 0,
                                  backgroundColor: 'transparent',
                                  textAlign: 'center',
                                }}
                                fullWidth
                                numeric={true}
                                selectTextOnFocus={true}
                                hideError={true}
                                rules={{
                                  required: true,
                                  pattern: {
                                    value: RegEx.tradeNum,
                                    message: 'Please enter a valid amount',
                                  },
                                  ...getFieldValidation(),
                                }}
                              />
                            </View>
                            {!isCommunityEvent && (
                              <>
                                <View style={{
                                  width: 1,
                                  alignSelf: 'stretch',
                                  backgroundColor: errors?.currentPrice ? Colors.red : globalConfigurableData.borderColor,
                                }} />
                                <TouchableOpacity
                                  onPress={() => onCounterPriceUpdate('increment')}
                                  style={{
                                    height: 46,
                                    width: 46,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                  }}>
                                  <Icon
                                    icon="mdi:plus"
                                    width={20}
                                    height={20}
                                    color={globalConfigurableData.primaryTextColor1}
                                  />
                                </TouchableOpacity>
                              </>
                            )}
                          </View>
                          {errors?.currentPrice?.type === 'required' && (
                            <FormTextLabel
                              labelStyles={globalStyle.errorText}
                              label={errors?.currentPrice.message}
                            />
                          )}
                          {(errors?.currentPrice?.type === 'min' ||
                            errors?.currentPrice?.type === 'max') && (
                            <FormTextLabel
                              labelStyles={globalStyle.errorText}
                              label={errors?.currentPrice.message}
                            />
                          )}
                        </View>
                      )}
                    </>
                  )}
                </>
              ) : null}
              <View
                style={{
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  marginBottom: 10,
                  marginTop: 10,
                }}>
                <FormTextLabel
                  labelStyles={styles.formTitle}
                  label={'Shares'}
                />
              </View>
              <View style={{
                flexDirection: 'row',
                alignItems: 'center',
                backgroundColor: globalConfigurableData.cardBgColor,
                borderRadius: 8,
                borderWidth: 1,
                overflow: 'hidden',
                borderColor: errors?.currentShare ? Colors.red : globalConfigurableData.borderColor,
              }}>
                <TouchableOpacity
                  onPress={() => onCounterShareUpdate('decrement')}
                  style={{
                    height: 46,
                    width: 46,
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}>
                  <Icon
                    icon="mdi:minus"
                    width={20}
                    height={20}
                    color={globalConfigurableData.primaryTextColor1}
                  />
                </TouchableOpacity>
                <View style={{
                  width: 1,
                  alignSelf: 'stretch',
                  backgroundColor: errors?.currentShare ? Colors.red : globalConfigurableData.borderColor,
                }} />
                <View style={{flex: 1}}>
                  <Input
                    name="currentShare"
                    placeholder=""
                    control={control}
                    variant="large"
                    disabled={!logedIn}
                    containerStyle={{marginBottom: 0}}
                    style={{borderWidth: 0}}
                    inputStyle={{
                      borderWidth: 0,
                      backgroundColor: 'transparent',
                      textAlign: 'center',
                    }}
                    fullWidth
                    numeric={true}
                    selectTextOnFocus={true}
                    hideError={true}
                    rules={{
                      required: true,
                      validate:
                        !eventDetails?.probe?.is_price_editable ? {} :
                        defaultRange.end === 1
                          ? {
                              checkShare: value => {
                                if (value % 10 !== 0) {
                                  return 'Quantity should be in multiples of 10';
                                } else {
                                  return true;
                                }
                              },
                            }
                          : defaultRange.end === 10
                          ? {
                              checkShare: value => {
                                if (value % 1 !== 0) {
                                  return 'Quantity should not be decimal';
                                } else {
                                  return true;
                                }
                              },
                            }
                          : defaultRange.end === 100 ? {
                            checkShare: value => {
                              if (!/^(\d+)?(($)|((\.\d{1})(0+$|$)))/.test(value)) {
                                return 'Quantity should not have more than one decimal place';
                              } else {
                                return true;
                              }
                            },
                          } : {},
                      min: {
                        value: !eventDetails?.probe?.is_price_editable
                          ? valueShareMaxHoldings.toFixed(2) < 0.1
                            ? valueShareMaxHoldings.toFixed(2)
                            : getMinSellSharesByPriceRange()
                          : getMinSellSharesByPriceRange(),
                        message: 'Quantity should be between 0.1 and 1000',
                      },
                      max: {
                        value: valueShareMaxHoldings.toFixed(2),
                        message: 'Quantity should be between 0.1 and 1000',
                      },
                    }}
                  />
                </View>
                <View style={{
                  width: 1,
                  alignSelf: 'stretch',
                  backgroundColor: errors?.currentShare ? Colors.red : globalConfigurableData.borderColor,
                }} />
                <TouchableOpacity
                  onPress={() => onCounterShareUpdate('increment')}
                  style={{
                    height: 46,
                    width: 46,
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}>
                  <Icon
                    icon="mdi:plus"
                    width={20}
                    height={20}
                    color={globalConfigurableData.primaryTextColor1}
                  />
                </TouchableOpacity>
              </View>
              {errors?.currentShare?.type === 'required' && (
                <FormTextLabel
                  labelStyles={globalStyle.errorText}
                  label={
                    valueShareMaxHoldings.toFixed(2) > 0
                      ? !eventDetails?.probe?.is_price_editable
                        ? valueShareMaxHoldings.toFixed(2) < 0.1
                          ? 'Quantity should be '
                          : 'Quantity should be between 0.1'
                        : 'Quantity should be between 1'
                      : 'Shares should be greater than 0'
                  }
                  rest={{
                    valueShareMaxHoldings: valueShareMaxHoldings.toFixed(2),
                    minShares: getMinSellSharesByPriceRange(),
                  }}
                />
              )}
              {(errors?.currentShare?.type === 'min' ||
                errors?.currentShare?.type === 'max') && (
                <FormTextLabel
                  labelStyles={globalStyle.errorText}
                  label={
                    valueShareMaxHoldings.toFixed(2) > 0
                      ? !eventDetails?.probe?.is_price_editable
                        ? valueShareMaxHoldings.toFixed(2) < 0.1
                          ? 'Quantity should be '
                          : 'Quantity should be between 0.1'
                        : 'Quantity should be between 1'
                      : 'Shares should be greater than 0'
                  }
                  rest={{
                    valueShareMaxHoldings: valueShareMaxHoldings.toFixed(2),
                    minShares: getMinSellSharesByPriceRange()
                  }}
                />
              )}
              {errors?.currentShare?.type === 'checkShare' && (
                <FormTextLabel
                  labelStyles={globalStyle.errorText}
                  label={errors?.currentShare.message}
                />
              )}
            </View>
            <View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 20,
                marginTop: 10,
              }}>
              <View style={{flexDirection: 'row', gap: 5}}>
                <FormTextLabel
                  labelStyles={styles.fieldBottomText}
                  label={'Available Shares: '}
                  rest={{
                    valueShareMaxHoldings: valueShareMaxHoldings.toFixed(2),
                  }}
                />
                <FormTextLabel
                  onPress={onMaxShare}
                  labelStyles={styles.maxShareText}
                  label={'Max'}
                />
              </View>
              {(!eventDetails?.probe?.is_price_editable &&
                eventDetails?.probe?.is_variable_liquidity_pool) ||
              !isLimit ? (
                <Slippage
                  slippages={slippage}
                  handleSlippage={handleSlippage}
                />
              ) : null}
            </View>

            {/* <View style={globalFormStyle.tableContainerRowNewForm}>
              <View>
                <Text style={globalFormStyle.fieldLeft}>
                  {!eventDetails?.probe.is_price_editable
                    ? "Est. Amount Received"
                    : "Potential Returns"}
                </Text>
              </View>

              <Text style={globalFormStyle.fieldRight}>
                {watchprice && watchshare
                  ? parseFloat(watchprice * watchshare - tradingFee).toFixed(2)
                  : 0}
              </Text>
            </View> */}
            <TradingFeeSellCDA
              isLimit={isLimit}
              configKey={isCDA ? 'tfCDASell' : 'tfIMSell'}
            />
          </TouchableOpacity>
        </ScrollView>
      </View>

      <View
        style={[
          globalStyle.customBtnParentModalStyle,
          {paddingHorizontal: 15, marginTop: 0},
        ]}>
        <Button
          variant={
            YesSelected
              ? isValid && !(valueShareMaxHoldings === 0)
                ? 'yes'
                : 'yes-inactive'
              : isValid && !(valueShareMaxHoldings === 0)
              ? 'no'
              : 'no-inactive'
          }
          onPress={() => {
            setTimeout(() => {
              handleSubmit(onPlaceOrder)();
            }, globalConst.buttonTimer);
          }}
          disabled={!isValid || valueShareMaxHoldings === 0}
          translate={true}
        >
          Confirm Order
        </Button>
      </View>
    </View>
  );
};

export default SingleOrderSell;

const styles = StyleSheet.create({
  btnExternalStyle: {
    borderRadius: 100,
  },
  formTitle: {
    ...globalFontStyle.appFontBody,
    color: globalConfigurableData.primaryTextColor1,
  },
  maxShareText: {
    ...globalFontStyle.appFontSmallTextBold,
    color: GlobalScreens.SingleOrder.highlightColor,
  },
  fieldBottomText: {
    ...globalFontStyle.appFontSmallText,
    color: globalConfigurableData.tertiaryTextColor1,
  },
  sliderMarkerStyle: {
    height: 20,
    width: 20,
    borderRadius: 10,

    top: 2,
    borderWidth: 1,
    backgroundColor: globalConfigurableData.globalThemeColor,
  },
  sliderLabelChild: {
    padding: 4,
    backgroundColor: Color.black,
    borderRadius: 5,
    alignItems: 'center',
  },
  sliderLableParent: {
    height: 30,
    width: 30,
    position: 'absolute',
    bottom: 40,
  },
  sliderTrackStyle: {
    height: 7,
    borderRadius: 5,
  },
});
